var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _path6, _linearGradient6, _path7, _path8, _linearGradient7, _path9, _linearGradient8, _path10, _linearGradient9, _path11, _linearGradient10, _path12, _linearGradient11, _path13, _linearGradient12, _path14, _linearGradient13, _path15, _linearGradient14, _path16, _linearGradient15, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiscalYearClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2",
    gradientUnits: "userSpaceOnUse",
    x1: -3805.107,
    y1: -13.591,
    x2: -3804.107,
    y2: -13.591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M121.339 110.976H43.618V31.499h111.627v38.867"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2",
    gradientUnits: "userSpaceOnUse",
    x1: 48.218,
    y1: 29.344,
    x2: 69.24,
    y2: 29.344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.467 30.125c0-5.115 4.146-9.261 9.261-9.261s9.261 4.146 9.261 9.261v7.699",
    fill: "none",
    stroke: "url(#SVGID_1_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2",
    gradientUnits: "userSpaceOnUse",
    x1: 127.845,
    y1: 29.344,
    x2: 148.868,
    y2: 29.344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.095 30.125c0-5.115 4.146-9.261 9.261-9.261s9.261 4.146 9.261 9.261v7.699",
    fill: "none",
    stroke: "url(#SVGID_2_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2",
    gradientUnits: "userSpaceOnUse",
    x1: 101.427,
    y1: 29.344,
    x2: 122.449,
    y2: 29.344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.677 30.125c0-5.115 4.146-9.261 9.261-9.261s9.261 4.146 9.261 9.261v7.699",
    fill: "none",
    stroke: "url(#SVGID_3_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2",
    gradientUnits: "userSpaceOnUse",
    x1: 75.008,
    y1: 29.344,
    x2: 96.031,
    y2: 29.344
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.258 30.125c0-5.115 4.146-9.261 9.261-9.261s9.261 4.146 9.261 9.261v7.699",
    fill: "none",
    stroke: "url(#SVGID_4_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M58.543 75.021h72.394M85.882 53.503v43.535M113.367 53.503v43.814"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2",
    gradientUnits: "userSpaceOnUse",
    x1: 57.293,
    y1: 53.253,
    x2: 141.705,
    y2: 53.253
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M58.543 53.253h81.912"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M121.165 97.296H58.129v-50.7h82.791v21.966"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2",
    gradientUnits: "userSpaceOnUse",
    x1: 126.351,
    y1: 77.706,
    x2: 166.024,
    y2: 77.706
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.601 86.999c0-10.265 8.321-18.586 18.586-18.586 10.265 0 18.586 8.321 18.586 18.586",
    fill: "none",
    stroke: "url(#SVGID_6_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2",
    gradientUnits: "userSpaceOnUse",
    x1: 120.68,
    y1: 106.668,
    x2: 171.379,
    y2: 106.668
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M121.93 87.696h48.199v37.944H121.93z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2",
    gradientUnits: "userSpaceOnUse",
    x1: 138.627,
    y1: 106.696,
    x2: 152.977,
    y2: 106.696
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M151.727 101.54a5.925 5.925 0 00-11.85 0c0 2.28 1.302 4.236 3.191 5.227v8.125a2.885 2.885 0 005.77 0v-8.288c1.723-1.036 2.889-2.906 2.889-5.064z",
    fill: "none",
    stroke: "url(#SVGID_8_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2",
    gradientUnits: "userSpaceOnUse",
    x1: 120.68,
    y1: 97.026,
    x2: 171.379,
    y2: 97.026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M127.601 86.999c0-10.265 8.321-18.586 18.586-18.586 10.265 0 18.586 8.321 18.586 18.586",
    fill: "none",
    stroke: "url(#SVGID_9_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2",
    gradientUnits: "userSpaceOnUse",
    x1: 120.68,
    y1: 97.026,
    x2: 171.379,
    y2: 97.026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M127.601 86.999c0-10.265 8.321-18.586 18.586-18.586 10.265 0 18.586 8.321 18.586 18.586",
    fill: "none",
    stroke: "url(#SVGID_10_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2",
    gradientUnits: "userSpaceOnUse",
    x1: 120.68,
    y1: 97.026,
    x2: 171.379,
    y2: 97.026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_11_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M121.93 87.696h48.199v37.944H121.93z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2",
    gradientUnits: "userSpaceOnUse",
    x1: 120.68,
    y1: 97.026,
    x2: 171.379,
    y2: 97.026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_12_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M121.93 87.696h48.199v37.944H121.93z"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2",
    gradientUnits: "userSpaceOnUse",
    x1: 120.68,
    y1: 97.026,
    x2: 171.379,
    y2: 97.026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M151.727 101.54a5.925 5.925 0 00-11.85 0c0 2.28 1.302 4.236 3.191 5.227v8.125a2.885 2.885 0 005.77 0v-8.288c1.723-1.036 2.889-2.906 2.889-5.064z",
    fill: "none",
    stroke: "url(#SVGID_13_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2",
    gradientUnits: "userSpaceOnUse",
    x1: 120.68,
    y1: 97.026,
    x2: 171.379,
    y2: 97.026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M151.727 101.54a5.925 5.925 0 00-11.85 0c0 2.28 1.302 4.236 3.191 5.227v8.125a2.885 2.885 0 005.77 0v-8.288c1.723-1.036 2.889-2.906 2.889-5.064z",
    fill: "none",
    stroke: "url(#SVGID_14_ba4a74fa409280cc4c91140bb1c3c17219f5dfacef1d20000e0a70e7000891e2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiscalYearClose);
export default __webpack_public_path__ + "static/media/fiscalYearClose.a4bd657e9c62e63aa32308e0274e2a83.svg";
export { ForwardRef as ReactComponent };